const UTILS = {
  FormSubmitAjax (form) {
    return fetch(form.action, { method: 'POST', body: new FormData(form) });
  },
  AddItemsToCart: (itemsToAdd) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    });
  },
  ChangeLineItem(p_options) {
    let data = {
      id: p_options.id || p_options.key,
      quantity: p_options.quantity || 1,
      properties: p_options.properties || {}
    }
  
    let url = `/cart/change.js`;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(res => res.json());
  },
  UpdateCartItems(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    }).then(res => res.json());
  },
  GetCartJson() {
    return fetch('/cart.js').then(res => res.json());
  },
  GetProductJS(product_handle) {
    return fetch(`/products/${ product_handle }.js`).then(res => res.json());
  },
  GetSections(sections) {
    return fetch(`/?sections=${ sections }`).then(res => res.json());
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('AddToCartOnPage', () => ({
    $button: null,
    init() {
      let am = this;
      document.addEventListener('init-AddToCartOnPage', (e) => {
        if (am.$button) return;
        am.$button = e.target;
      });
    },
    SubmitAddToCartForm(e) {
      let am = this;
      e.preventDefault();
      const CLASS_ADDED_TO_CART = 'add-to-cart-complete';
      let $form = e.target.closest('.product-single__form');
      if (am.$button.classList.contains(CLASS_ADDED_TO_CART)) {
        window.location.href = '/cart';
        return;
      }

      (async() => {
        let rx_form = await UTILS.FormSubmitAjax($form);
        if (rx_form.ok) {
          am.$button.querySelector('[data-add-to-cart-text]').textContent = 'Added! Click to View Cart';
          am.$button.classList.add(CLASS_ADDED_TO_CART);
          am.RefreshCart();
        }
        else {
          console.error(rx_form.error);
        }
      })();
    },
    RefreshCart() {
      document.querySelectorAll('.cart-link__bubble').forEach(($cart_bubble) => {
        $cart_bubble.classList.add('cart-link__bubble--visible');
      });
    }
  }));

  Alpine.data('CustomDropdown', () => ({
    $section: null,
    init() {
      let am = this;
      document.addEventListener('init-CustomDropdown', (e) => {
        if (am.$section) return;
        am.$section = e.target;
      });
    },
    CloseDropdown(e) {
      let am = this;
      am.$section.removeAttribute('open');
    }
  }));

  Alpine.data('ProductFormGridItem', () => ({
    $section: null,
    selected_variant_title: '',
    init() {
      let am = this;
      document.addEventListener('init-ProductFormGridItem', (e) => {
        if (am.$section) return;
        am.$section = e.target;
      });
    }
  }));

  Alpine.data('CartAddon', (addon_handle) => ({
    $section: null,
    addonProduct: null,
    init() {
      let am = this;
      document.addEventListener('init-CartAddon', (e) => {
        if (am.$section) return;
        am.$section = e.target;
      });

      // load addon product
      (async() => {
        let product = await UTILS.GetProductJS(addon_handle);
        am.addonProduct = product;
        setTimeout(am.UpdateAddons.bind(am), 1000); // on page load
      })();
    },
    UpdateAddons(e) {
      let am = this;
      let line_item_key = am.$section.dataset.key;

      (async() => {
        let cart = await UTILS.GetCartJson();
        let line_item = cart.items.find(item => item.key == line_item_key);

        // update main item to indicate which addon variant goes together
        if (e) {
          let addon_variant_id = e.target.value;
          let color = e.target.dataset.color;
          cart = await UTILS.ChangeLineItem({
            id: line_item_key,
            quantity: line_item.quantity,
            properties: {
              _addon: addon_variant_id,
              'Metal Tip': color
            }
          });  
        }

        // update addon variant
        let lineitems_req_addons = cart.items.filter(item => item.properties['_addon'] && item.properties['_addon'] !== 'None');
        let req_addons = lineitems_req_addons.map(item => item.properties['_addon']);
        req_addons = [...new Set(req_addons)]; // remove duplicates

        // calculate qty for each addon variant
        req_addons = req_addons.map((addon_variant_id) => {
          let qty = 
            cart.items
            .filter(item => item.properties && item.properties['_addon'] == addon_variant_id)
            .reduce((sum, item) => (sum + item.quantity), 0);
          return {
            id: addon_variant_id,
            quantity: qty
          };
        });

        let cart_addons_updates = {};

        am.addonProduct.variants.forEach((addon_variant) => {
          let item_in_cart = cart.items.find(item => item.id == addon_variant.id);
          let req_item = req_addons.find(item => item.id == addon_variant.id);
          let req_qty = req_item ? req_item.quantity : 0;

          let quantity = req_qty;

          if (item_in_cart) {
            if (item_in_cart.quantity !== quantity) {
              cart_addons_updates[addon_variant.id] = quantity;
            }
          }
          else {
            if (quantity > 0) {
              cart_addons_updates[addon_variant.id] = quantity;
            }
          }
        });

        // debugger;
        if (JSON.stringify(cart_addons_updates) !== '{}') {
          await UTILS.UpdateCartItems(cart_addons_updates)
          am.RefreshCart();
        }
      })();
    },
    RefreshCart() {
      let am = this;
      // window.location.reload();
      (async() => {
        let res_cart = await UTILS.GetSections('main-cart');
        // document.querySelector('shopify-section-main-cart').innerHTML = res_cart['main_cart'];

        let $main_cart = UTILS.ConvertStringToHTML(res_cart['main-cart']);
        document.querySelector('#cart-page-content').innerHTML = $main_cart.querySelector('#cart-page-content').innerHTML;
        AOS.init();

        var cartPageForm = document.getElementById('CartPageForm');
        if (cartPageForm) {
          new theme.CartForm(cartPageForm);
        }  
      })();
    }
  }));
});

function initSizeChartContent(scope = document) {
  const containers = scope.querySelectorAll('[data-size-chart-content]');

  const isTableContentNode = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    const tagName = node.tagName.toLowerCase();

    if (tagName === 'table') {
      return true;
    }

    return tagName === 'div' && node.classList.contains('table-wrapper');
  };

  containers.forEach((container) => {
    if (container.dataset.sizeChartContentInitialized === 'true') {
      return;
    }

    const source = container.querySelector('[data-size-chart-content-source]');
    const preview = container.querySelector('[data-size-chart-content-preview]');
    const toggle = container.querySelector('[data-size-chart-content-toggle]');
    const toggleLabel = container.querySelector('[data-size-chart-content-toggle-label]');
    const content = container.querySelector('[data-size-chart-content-content]');
    const contentInner = container.querySelector('[data-size-chart-content-content-inner]');

    if (!source || !preview || !toggle || !toggleLabel || !content || !contentInner) {
      return;
    }

    const nodes = Array.from(source.childNodes).filter((node) => {
      return node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== '';
    });

    if (!nodes.length) {
      return;
    }

    const previewNodes = [];
    const remainingNodes = [];
    let hasTable = false;
    let hasParagraph = false;

    nodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const tagName = node.tagName.toLowerCase();

        if (!hasTable && isTableContentNode(node)) {
          previewNodes.push(node.cloneNode(true));
          hasTable = true;
          return;
        }

        if (!hasParagraph && tagName === 'p') {
          previewNodes.push(node.cloneNode(true));
          hasParagraph = true;
          return;
        }
      }

      remainingNodes.push(node.cloneNode(true));
    });

    if (!previewNodes.length) {
      return;
    }

    previewNodes.forEach((node) => {
      preview.appendChild(node);
    });

    const hasRemainingContent = remainingNodes.some((node) => {
      return node.nodeType === Node.ELEMENT_NODE || node.textContent.trim() !== '';
    });

    if (hasRemainingContent) {
      remainingNodes.forEach((node) => {
        contentInner.appendChild(node);
      });

      content.classList.remove('hide');
      toggle.classList.remove('hide');

      if (window.theme && theme.collapsibles && typeof theme.collapsibles.init === 'function') {
        theme.collapsibles.init(container);
      }

      if (toggle.dataset.sizeChartContentToggleBound !== 'true') {
        toggle.addEventListener('click', () => {
          window.requestAnimationFrame(() => {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggleLabel.textContent = isExpanded
              ? toggle.dataset.readLessText
              : toggle.dataset.readMoreText;
          });
        });

        toggle.dataset.sizeChartContentToggleBound = 'true';
      }
    }

    preview.classList.remove('hide');
    source.classList.add('hide');
    container.dataset.sizeChartContentInitialized = 'true';
  });
}

initSizeChartContent();
document.addEventListener('shopify:section:load', (event) => {
  initSizeChartContent(event.target);
});


function initCartAddonModal(){
    const modals = document.querySelectorAll('.js-cart-addon-modal');
    if(!modals) return;
    modals.forEach(modal=>{
        new theme.Modals(modal.id, modal.id);
    })
}
initCartAddonModal();
if (!customElements.get('cart-addon')) {
    customElements.define('cart-addon', class CartAddon extends HTMLElement {
        constructor() {
            super();

            try {
                this.mainItem = JSON.parse(this.querySelector('[type="application/json"]').textContent);
            } catch (e) {
                console.error('Invalid JSON in cart-addon:', e);
                return;
            }

            this.maxQuantity = Number(this.dataset.maxQuantity);
            this.variantQuantity = this.querySelectorAll('.variant-row-quantity .js-qty__num');
            this.variantQuantityPlus = this.querySelectorAll('.variant-row-quantity .js-qty__adjust--plus');
            this.variantQuantityButton = this.querySelectorAll('.variant-row-quantity .js-qty__adjust');
            this.submitButton = this.querySelector('.cart-addon-modal-button');
            this.modalInfo = this.querySelector('.cart-addon-modal-info');

            this.variantQuantity.forEach(input =>
                input.addEventListener("change", this.changeHandler.bind(this))
            );
            this.variantQuantityButton.forEach(button =>
                button.addEventListener("click", this.changeHandler.bind(this))
            );
            if (this.submitButton) {
                this.submitButton.addEventListener('click', this.submitHandler.bind(this));
            }
        }

        changeHandler () {
            setTimeout( () => {
                this.quantityValidation();
            }, 100)
        };

        quantityValidation () {
            const totalItemsQuantity = Array.from(this.variantQuantity)
                .reduce((sum, input) => sum + Number(input.value), 0);

            const disableInputs = (disable) => {
                this.variantQuantity.forEach(input =>
                    input.toggleAttribute("disabled", disable)
                );
                this.variantQuantityPlus.forEach(button =>
                    button.toggleAttribute("disabled", disable)
                );
            };

            if(totalItemsQuantity === 0){
                this.submitButton?.toggleAttribute("disabled", true);
                disableInputs(false);
            }else if (totalItemsQuantity === this.maxQuantity) {
                this.quantityError(false);
                disableInputs(true);
            } else if (totalItemsQuantity > this.maxQuantity) {
                this.quantityError(true);
                disableInputs(true);
            } else {
                disableInputs(false);
                this.quantityError(false);
            }
        };

        quantityError (disabled) {
            this.submitButton?.toggleAttribute("disabled", disabled);
            this.modalInfo?.classList.toggle("has-error", disabled);
        };

        async submitHandler ()  {
            const items = this.getItemsToAdd();
            if(items.length > 0){
                this.submitButton?.classList.add('loading')
                await this.removeAllAddons();
                await this.addToCart();
                await this.updateCartItem();
                this.closePopup();
                document.dispatchEvent(new CustomEvent('cart:build'));
            }
        };

        getItemsToAdd () {
            return Array.from(this.variantQuantity)
                .map(input => ({
                    id: input.dataset.variantId,
                    quantity: Number(input.value),
                    properties: {
                        "_addon_item_id": `${this.mainItem.handle}-${this.mainItem.variant_id}`,
                        "Product": `${this.mainItem.product_title} ${this.mainItem.variant_title}`
                    }
                }))
                .filter(item => item.quantity > 0);
        };
        getItemsToRemove () {
            const updates = {}
            this.variantQuantity.forEach(item=>{
                if(item.dataset.key){
                    updates[item.dataset.key] = 0
                }
            })
            return updates
        };

        async addToCart() {
            const items = this.getItemsToAdd();
            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                });
                await response.json();
                console.log("success");
            } catch (error) {
                console.error('Error:', error);
            }
        }
        async removeAllAddons() {
            const updates = this.getItemsToRemove();
            console.log(updates)
            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates })
                });
                await response.json();
                console.log("success");
            } catch (error) {
                console.error('Error:', error);
            }
        }

        async updateCartItem() {
            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: this.mainItem.key,
                        quantity: this.mainItem.quantity,
                        properties: { '_addon_item_main_id': `${this.mainItem.handle}-${this.mainItem.variant_id}` }
                    })
                });
                await response.json();
                console.log("success");
            } catch (error) {
                console.error('Error:', error);
            }
        }
        closePopup(){
            this.closest('.modal')?.querySelector('.modal__close')?.click();
        }
    });
}

async function removeOrphanAddonsSingleRequest(dispatchBuildEvent = true) {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const updates = {};
    cart.items.forEach(item => {
      const addonId = item.properties?._addon_item_id;
      if (!addonId) return;

      const mainExists = cart.items.some(
        mainItem => mainItem.properties?._addon_item_main_id === addonId
      );

      if (!mainExists) {
        updates[item.key] = 0;
      }
    });


    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      console.log(`${Object.keys(updates).length} blank addon items removed in a single request.`);
      if (dispatchBuildEvent) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
      
      // window.location.reload();
    } else {
      console.log('No blank addon items found.');
    }

  } catch (error) {
    console.error('Error updating cart:', error);
  }
}
document.addEventListener('cart:updated', function (){
  removeOrphanAddonsSingleRequest();
});

removeOrphanAddonsSingleRequest();

// Cartly Cart Drawer customization
(async () => {
  const cartlyMarker = document.body.querySelector('#spurit-occ3-hidden-acb-container');
  if (!cartlyMarker) {
    return;
  }

  const MAIN_ITEM_PROP = '_addon_item_main_id';
  const ADDON_ITEM_PROP = '_addon_item_id';

  let modal = null;
  let addon = null;

  const getCartItems = () => Spurit.global.cartPool.getAdapter().getItems();

  const groupCartItems = items => {
    const groupedItems = {};
    items.forEach(i => {
      const itemKey = i.properties[MAIN_ITEM_PROP] || i.properties[ADDON_ITEM_PROP] || i.key;
      if (!groupedItems[itemKey]) {
        groupedItems[itemKey] = {item: null, addons: []};
      }

      if (i.properties[ADDON_ITEM_PROP]) {
        groupedItems[itemKey].addons.push(i);
      } else {
        groupedItems[itemKey].item = i;
      }
    });

    return groupedItems;
  };

  const findItemCardByKey = key => {
    const cards = [...document.body.querySelectorAll('.spurit-occ3__product-card')];
    return cards.find(c => c.dataset.occ3CartKey === key)
  };

  const regroupCartItemCards = () => {
    const container = document.body.querySelector('.spurit-occ3__product-cards');
    if (!container) {
      return;
    }

    const groupedItems = groupCartItems(getCartItems());
    for (let key in groupedItems) {
      const group = groupedItems[key];

      const wrapper = document.createElement('div');
      wrapper.className = 'cartly-cart-item-group-wrapper';

      if (group.item) {
        const mainCard = findItemCardByKey(group.item.key);
        if (mainCard) {
          wrapper.appendChild(mainCard);
        }
      }

      group.addons.forEach(addon => {
        const addonCard = findItemCardByKey(addon.key);
        if (addonCard) {
          addonCard.classList.add('addon');
          wrapper.appendChild(addonCard);
        }
      });

      if (container.children.length) {
        container.insertBefore(wrapper, container.firstElementChild);
      } else {
        container.appendChild(wrapper);
      }
    }
  }

  const loadAddonProduct = () => {
    return fetch('/products/premium-add-on-aglet-tips.json').then(r => r.json()).then(result => {
      addon = result.product;
    }).catch(e => console.warn('Error while loading addon product'));
  }

  const getAddonProduct = async () => {
    if (!addon) {
      await loadAddonProduct();
    }

    return addon;
  }

  const makeUpgradeButton = async (isEdit = false) => {
    const product = await getAddonProduct();

    const btnIcon = document.createElement('div');
    btnIcon.className = 'cartly-addon-btn__icon';
    btnIcon.innerHTML = `
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.75 10.5C7.75 10.9142 7.41421 11.25 7 11.25C6.58579 11.25 6.25 10.9142 6.25 10.5V5.31066L5.03033 6.53033C4.73744 6.82322 4.26256 6.82322 3.96967 6.53033C3.67678 6.23744 3.67678 5.76256 3.96967 5.46967L6.46967 2.96967C6.76256 2.67678 7.23744 2.67678 7.53033 2.96967L10.0303 5.46967C10.3232 5.76256 10.3232 6.23744 10.0303 6.53033C9.73744 6.82322 9.26256 6.82322 8.96967 6.53033L7.75 5.31066V10.5Z" fill="#525252"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7Z" fill="#525252"/>
      </svg>
    `;

    const btnText = document.createElement('div');
    btnText.innerHTML = isEdit ? 'Edit your metal tips' : 'Upgrade to metal tips';

    const btnContent = document.createElement('div');
    btnContent.className = 'cartly-addon-btn__content';
    btnContent.appendChild(btnIcon);
    btnContent.appendChild(btnText);

    const btn = document.createElement('button');
    btn.setAttribute('data-upgrade-btn', 'true');
    btn.className = 'cartly-addon-btn';
    btn.appendChild(btnContent);

    return btn;
  };

  const addUpgradeButtons = cartContainer => {
    const items = getCartItems();
    items.forEach(async i => {
      if (!i.product.tags.includes('add-on')) {
        return;
      }

      const itemElement = cartContainer.querySelector(`[data-occ3-cart-key="${i.key}"]`);
      const hasAddon = i.properties[MAIN_ITEM_PROP] && items.some(item => item.properties[ADDON_ITEM_PROP] === i.properties[MAIN_ITEM_PROP]);
      const btn = await makeUpgradeButton(hasAddon);
      itemElement?.appendChild(btn);
    });
  }

  const getAddonVariantQuantityControls = (variantId) => {
      const variantQuantity = document.createElement('div');
      variantQuantity.className = 'addon-quantity';
      variantQuantity.innerHTML = '0';
      variantQuantity.setAttribute('data-variant-id', variantId);

      const minusButton = document.createElement('button');
      minusButton.setAttribute('data-action-decrease', 1);
      minusButton.innerHTML = '-';

      const plusButton = document.createElement('button');
      plusButton.setAttribute('data-action-increase', 1);
      plusButton.innerHTML = '+';

      const container = document.createElement('div');
      container.className = 'addon-quantity-controls';
      container.appendChild(minusButton);
      container.appendChild(variantQuantity);
      container.appendChild(plusButton);

      return container;
  }

  const initUpgradeModal = async () => {
    if (modal) {
      return;
    }

    const product = await getAddonProduct();
    const modalTemplate = document.body.querySelector('[data-cart-drawer-addon-template]');
    modalTemplate.remove();
    modal = modalTemplate.firstElementChild;
    modal.setAttribute('data-addon-modal', 'true');
    
    const titleElement = modal.querySelector('.spurit-occ3__bundle-title');
    titleElement.innerHTML = product.title;

    const variantsContainer = modal.querySelector('.spurit-occ3__variant-group');
    product.variants.forEach(v => {
      let variantImage = null;
      if (v.image_id) {
        variantImage = document.createElement('img');
        variantImage.src = product.images.find(i => i.id === v.image_id).src;
      }
      
      const variantTitle = document.createElement('div');
      variantTitle.innerHTML = v.title;

      const variantPrice = document.createElement('div');
      variantPrice.className = 'spurit-occ3__variant-price';
      variantPrice.innerHTML = `$ ${v.price}`;

      const variantQuantity = getAddonVariantQuantityControls(v.id);

      const option = document.createElement('div');
      option.className = 'spurit-occ3__variant';
      if (variantImage) {
        option.appendChild(variantImage);
      }
      option.appendChild(variantTitle);
      option.appendChild(variantPrice);
      option.appendChild(variantQuantity);
      
      variantsContainer.appendChild(option);
    });
  }

  const addUpgradeModal = cartContainer => {
    cartContainer.querySelector('.spurit-occ3__slide-drawer').appendChild(modal);
  };

  const makeDiscountBadge = name => {
    const icon = document.createElement('div');
    icon.className = 'cartly-discount-icon';
    icon.innerHTML = '<svg viewBox="0 0 20 20" class="Icon_Icon__uZZKy" style="width: 20px; height: 20px;"><path d="M12.78 8.28a.75.75 0 0 0-1.06-1.06l-4.5 4.5a.75.75 0 1 0 1.06 1.06l4.5-4.5Z"></path><path d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path><path d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M12.094 3.514c-.822-1.79-3.366-1.79-4.188 0a.804.804 0 0 1-1.011.42c-1.848-.686-3.647 1.113-2.962 2.96a.804.804 0 0 1-.419 1.012c-1.79.822-1.79 3.366 0 4.188a.805.805 0 0 1 .42 1.011c-.686 1.848 1.113 3.647 2.96 2.962a.805.805 0 0 1 1.012.419c.822 1.79 3.366 1.79 4.188 0a.805.805 0 0 1 1.011-.42c1.848.686 3.647-1.113 2.962-2.96a.805.805 0 0 1 .419-1.012c1.79-.822 1.79-3.366 0-4.188a.805.805 0 0 1-.42-1.011c.686-1.848-1.113-3.647-2.96-2.962a.805.805 0 0 1-1.012-.419Zm-2.825.626a.804.804 0 0 1 1.462 0 2.304 2.304 0 0 0 2.896 1.2.804.804 0 0 1 1.034 1.034 2.304 2.304 0 0 0 1.199 2.895.804.804 0 0 1 0 1.462 2.304 2.304 0 0 0-1.2 2.896.805.805 0 0 1-1.034 1.034 2.304 2.304 0 0 0-2.895 1.199.804.804 0 0 1-1.462 0 2.304 2.304 0 0 0-2.896-1.2.804.804 0 0 1-1.033-1.034 2.305 2.305 0 0 0-1.2-2.895.804.804 0 0 1 0-1.462 2.304 2.304 0 0 0 1.2-2.896.804.804 0 0 1 1.033-1.033 2.304 2.304 0 0 0 2.896-1.2Z"></path></svg>'
    
    const text = document.createElement('div');
    text.className = 'cartly-discount-name';
    text.innerHTML = name;

    const badge = document.createElement('div');
    badge.className = 'cartly-discount-badge';
    badge.appendChild(icon);
    badge.appendChild(text);

    return badge;
  }

  const updateDiscounts = cartContainer => {
    const cards = [...cartContainer.querySelectorAll('.spurit-occ3__product-card')];

    getCartItems().forEach(item => {
      if (!item.discounts?.length || item.properties[ADDON_ITEM_PROP]) return;

      const itemCard = cards.find(card => card.dataset.occ3CartKey === item.key);
      if (!itemCard) return;

      const badge = makeDiscountBadge(item.discounts[0].title);
      const infoBlock = itemCard.querySelector('.spurit-occ3__item-titles');
      infoBlock.appendChild(badge);

      const saveLabel = itemCard.querySelector('.spurit-occ3-saved-amount');
      if (!saveLabel) return;

      const price = itemCard.querySelector('.spurit-occ3__price');
      price.appendChild(price.firstElementChild);
    });
  }

  const updateCartDrawer = cartContainer => {
    regroupCartItemCards(cartContainer);
    addUpgradeModal(cartContainer);
    addUpgradeButtons(cartContainer);
    disableQuantityControls(cartContainer);
    updateDiscounts(cartContainer);
  };

  const resetModalQuantityBoxes = (mainItem) => {
    const items = getCartItems();
    getQuantityBoxes().forEach(box => {
      const mainItemProp = mainItem.properties[MAIN_ITEM_PROP];
      if (!mainItemProp) {
        box.innerHTML = 0;
        return;
      }

      const addon = items.find(i => +box.dataset.variantId === i.variant_id && mainItemProp === i.properties[ADDON_ITEM_PROP]);
      box.innerHTML = addon?.quantity || 0;
    });
  }

  const openUpgradeModal = (item) => {
    modal.setAttribute('data-item-key', item.key);
    modal.setAttribute('data-max-addons', item.quantity);
    resetModalQuantityBoxes(item);

    const infoBlock = modal.querySelector('.max-addons-info');
    infoBlock.innerHTML = `You can add maximum ${item.quantity} tip${item.quantity > 1 ? 's' : ''}`;

    modal.classList.add('is-visible');
  }

  const closeUpgradeModal = () => {
    modal.classList.remove('is-visible');
  }

  const getMainItem = () => {
    const cartItems = getCartItems();
    return cartItems.find(item => item.key === modal.dataset.itemKey);
  }

  const disableQuantityControls = () => {
    const items = getCartItems();
    items.filter(item => item.properties[MAIN_ITEM_PROP]).forEach(item => {
      const itemCard = findItemCardByKey(item.key);
      if (!itemCard) {
        return;
      }

      let addonsCount = 0;
      items.forEach(i => {
        if (i.properties[ADDON_ITEM_PROP] !== item.properties[MAIN_ITEM_PROP]) {
          return;
        }

        addonsCount += i.quantity;
        const addonCard = findItemCardByKey(i.key);
        const controls = addonCard.querySelector('.spurit-num-input');
        [...controls.querySelectorAll('button, input')].forEach(elem => elem.setAttribute('disabled', true));
      });

      if (addonsCount >= item.quantity) {
        const itemControls = itemCard.querySelector('.spurit-num-input');
        [...itemControls.querySelectorAll('.spurit-ni-button-left, input')].forEach(elem => elem.setAttribute('disabled', true));
      }
    });


  }

  const getQuantityBoxes = () => {
    return [...modal.querySelectorAll('.spurit-occ3__variant .addon-quantity')];
  }

  const cartOperations = {
    submit: async () => {
      const items = cartOperations.getItemsToAdd();
      if (items.length <= 0) {
        return;
      }

      modal.querySelector('.spurit-occ3__confirm-button').classList.add('loading');
      await cartOperations.removeAllAddons();
      await cartOperations.addToCart();
      await cartOperations.updateCartItem();
      modal.querySelector('.spurit-occ3__confirm-button').classList.remove('loading');
      closeUpgradeModal();
    },

    getItemsToAdd: () => {
      const variantSelect = modal.querySelector('.spurit-occ3__variant-select');
      const mainItem = getMainItem();

      return getQuantityBoxes().map(box => ({
        id: +box.dataset.variantId,
        quantity: +box.innerHTML,
        properties: {
          [ADDON_ITEM_PROP]: `${mainItem.handle}-${mainItem.variant_id}`,
          "Product": `${mainItem.product_title} ${mainItem.variant_title}`
        }
      }));
    },

    getItemsToRemove: () => {
      const updates = {};
      const mainItem = getMainItem();

      getCartItems().forEach(i => {
        if (i.properties[ADDON_ITEM_PROP] === `${mainItem.handle}-${mainItem.variant_id}`) {
          updates[i.key] = 0;
        }
      });

      return updates;
    },

    addToCart: async () => {
      const items = cartOperations.getItemsToAdd();
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        });
        await response.json();
      } catch (error) {
        console.error('Error:', error);
      }
    },

    removeAllAddons: async () => {
      const updates = cartOperations.getItemsToRemove();
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        await response.json();
      } catch (error) {
        console.error('Error:', error);
      }
    },

    updateCartItem: async () => {
      try {
        const mainItem = getMainItem();
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: mainItem.key,
            quantity: mainItem.quantity,
            properties: {[MAIN_ITEM_PROP]: `${mainItem.handle}-${mainItem.variant_id}`}
          })
        });
        await response.json();
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.addedNodes?.length && mutation.addedNodes[0].className === 'spurit-occ3-container') {
        updateCartDrawer(mutation.addedNodes[0]);
      }
    }
  });

  const removeAddonsFromCart = item => {
    const items = getCartItems();
    const addons = items.forEach(i => {
      if (i.properties[ADDON_ITEM_PROP] === item.properties[MAIN_ITEM_PROP]) {
        i.remove();
      }
    });
  }

  const fixAddonQuantity = box => {
    if (!box.innerHTML || isNaN(box.innerHTML) || box.innerHTML < 0) {
      box.innerHTML = 0;
    }
  }

  const fixTotalAddons = lastBox => {
    const boxes = getQuantityBoxes();
    const totalAddons = boxes.reduce((sum, b) => sum + +b.innerHTML, 0);
    if (totalAddons > modal.dataset.maxAddons) {
      const diff = totalAddons - modal.dataset.maxAddons;
      lastBox.innerHTML = Math.max(0, lastBox.innerHTML - diff);
    }
  }

  const handleAjustmentButtonClick = button => {
    const quantityBox = button.parentElement.querySelector('.addon-quantity');
    if (button.dataset.actionIncrease) {
      quantityBox.innerHTML = +quantityBox.innerHTML + 1;
    } else {
      quantityBox.innerHTML = +quantityBox.innerHTML - 1;
    }

    fixAddonQuantity(quantityBox);
    fixTotalAddons(quantityBox);
  }

  const initListeners = () => {
    document.body.addEventListener('click', e => {
      if (e.target.closest('[data-occ3="remove-button"]')) {
        const removedItemCard = e.target.closest('.spurit-occ3__product-card');
        const removedItem = getCartItems().find(i => i.key === removedItemCard.dataset.occ3CartKey);
        if (removedItem.properties[MAIN_ITEM_PROP]) {
          removeAddonsFromCart(removedItem);
        }

        return;
      }

      if (e.target.closest('[data-upgrade-btn]')) {
        const itemCard = e.target.closest('.spurit-occ3__product-card');
        const item = getCartItems().find(i => i.key === itemCard.dataset.occ3CartKey);
        openUpgradeModal(item);
        return;
      }

      if (e.target.tagName === 'BUTTON' && e.target.closest('.addon-quantity-controls')) {
        handleAjustmentButtonClick(e.target);
        return;
      }

      if (e.target.closest('.spurit-occ3__confirm-button')) {
        cartOperations.submit();
        return;
      }

      if (e.target.closest('[data-addon-modal] .spurit-occ3__volume-upsell-close')) {
        closeUpgradeModal();
        return;
      }

      if (!e.target.closest('.spurit-occ3__volume-upsell-content')) {
        closeUpgradeModal();
        return;
      }
    });
  };

  await initUpgradeModal();
  initListeners();

  observer.observe(document.body, {childList: true, subtree: true});
})();
/* ==========================================================================
   Lazy hover image for product cards
   The second product image is not rendered for every card. Each card wrapper
   that can show a hover image carries data-hover-src / data-hover-srcset /
   data-hover-alt, and the .grid-product__secondary-image subtree is built the
   first time the pointer enters the card. The generated markup reuses the
   theme's existing .grid-product__secondary-image classes, so the fade-in
   animation and object-fit styling are unchanged.

   Delegated from document so cards re-rendered by the collection filter
   AJAX are picked up automatically.
   ========================================================================== */
(() => {
  const HOVER_ATTR = 'data-hover-src';

  const buildHoverImage = (content) => {
    const primary = content.querySelector('img');
    if (!primary) return null;

    const wrap = document.createElement('div');
    wrap.className = 'grid-product__secondary-image small--hide';

    const img = document.createElement('img');
    // Reuse the primary image classes minus the AOS helper class, which is
    // opacity:0 until AOS marks it as animated.
    img.className = (primary.className || '')
      .split(/\s+/)
      .filter((c) => c && c !== 'image-element')
      .join(' ');
    img.alt = content.getAttribute('data-hover-alt') || '';
    img.decoding = 'async';
    img.sizes = primary.getAttribute('sizes') || '';
    img.srcset = content.getAttribute('data-hover-srcset') || '';
    // no loading="lazy" here: the element is still detached at this point and a
    // lazy image that is not rendered never starts loading, so decode() below
    // would never settle.
    img.src = content.getAttribute(HOVER_ATTR) || '';

    if (!img.src) return null;

    wrap.appendChild(img);
    return wrap;
  };

  const attach = (content) => {
    const wrap = buildHoverImage(content);
    if (!wrap) {
      content.setAttribute('data-hover-skip', '1');
      return;
    }

    const img = wrap.firstChild;
    // The generated image is absolutely positioned, so it must be appended to
    // the ratio/image box rather than the card wrapper: the wrapper also
    // contains the title and price.
    const host = content.querySelector('.grid__image-ratio, .image-wrap') || content;
    let shown = false;
    const show = () => {
      if (shown) return;
      shown = true;
      host.appendChild(wrap);
    };

    // Wait for the image so the existing fade-in animation is not wasted on a
    // blank frame, but never block on a stalled request.
    if (typeof img.decode === 'function') {
      Promise.race([
        img.decode().catch(() => {}),
        new Promise((resolve) => setTimeout(resolve, 1200)),
      ]).then(show);
    } else if (img.complete) {
      show();
    } else {
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', show, { once: true });
    }
  };

  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) {
    return; // touch devices hide .grid-product__secondary-image anyway
  }

  document.addEventListener('mouseover', (e) => {
    if (!(e.target instanceof Element)) return;
    const content = e.target.closest('[' + HOVER_ATTR + ']');
    if (!content) return;
    if (content.getAttribute('data-hover-skip') || content.dataset.hoverPending) return;
    content.dataset.hoverPending = '1';
    attach(content);
  });
})();
